import i18next from 'i18next';

i18next.addResources('es', 'EvidenceButtons', {
  addEvidence: 'Agregar prueba',
  evidenceOpening: 'Auto de apertura a prueba',
  generateReport: 'Generar informe de pruebas'
});
